import React, { createContext, useContext } from 'react';

import type { PostTypeDataMap } from 'src/app/pages/starterDashboardV2/shared/types';
import type { EnrichedReadyToSharePlatformPostsV2 } from 'src/app/shared/api/readyToShare';
import { useScrollToHash } from 'src/app/shared/hooks/useScrollToHash';

type ReadyToShareContextType = {
	data: {
		isOpen: boolean;
		shouldShowReadyToShareExperiment: boolean;
		isLoading: boolean;
		readyToSharePostsValue?: EnrichedReadyToSharePlatformPostsV2;
		postTypeData: PostTypeDataMap;
	};
	actions: {
		openSharePreviewModal: () => void;
		closeSharePreviewModal: () => void;
		trackView: (currentPosition: string) => void;
	};
};

const ReadyToShareContext = createContext<ReadyToShareContextType | undefined>(undefined);

export const useReadyToShareContext = () => {
	const context = useContext(ReadyToShareContext);
	if (context === undefined) {
		throw new Error('useReadyToShareContext must be used within a ReadyToShareProvider');
	}
	return context;
};

export const ReadyToShareProvider: React.FC<React.PropsWithChildren<{ value: ReadyToShareContextType }>> = ({
	value,
	children,
}) => {
	const {
		data: { isLoading, shouldShowReadyToShareExperiment },
	} = value;

	useScrollToHash({
		elementId: 'ready-to-share-posts',
		targetHash: '#ready-to-share-posts',
		enabled: shouldShowReadyToShareExperiment && !isLoading,
	});

	return <ReadyToShareContext.Provider value={value}>{children}</ReadyToShareContext.Provider>;
};
